import React from "react";
import "./styles.scss";

export const HeaderText = ({ text }) => {
  return <div className="typ-header-text">{text}</div>;
};

export const SubText = ({ text }) => {
  return <div className="typ-sub-text">{text}</div>;
};
export const FormText = ({ text }) => {
  return <div className="form-text">{text}</div>;
};

export const PopupHeaderText = ({ text }) => {
  return <div className="popup-header-text">{text}</div>;
};

export const PopupSubText = ({ text }) => {
  return <div className="popup-sub-text">{text}</div>;
};

export const SmallLightText = ({ text }) => {
  return <div className="detail-small-light">{text}</div>;
};

export const SmallBoldText = ({ text }) => {
  return <div className="detail-small-bold">{text}</div>;
};

export const MidLightText = ({ text }) => {
  return <div className="detail-mid-light">{text}</div>;
};